import { render, staticRenderFns } from "./FifaTwitterCompetition.vue?vue&type=template&id=f10806a8&scoped=true&"
import script from "./FifaTwitterCompetition.vue?vue&type=script&lang=js&"
export * from "./FifaTwitterCompetition.vue?vue&type=script&lang=js&"
import style0 from "./FifaTwitterCompetition.vue?vue&type=style&index=0&id=f10806a8&scoped=true&lang=scss&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "f10806a8",
  null
  
)

export default component.exports